import validate from "/opt/simploshop/node_modules/.pnpm/nuxt@4.0.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-_146d17ab30a9bf24368648cb0b07bbfb/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/simploshop/shared/core-theme/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/opt/simploshop/node_modules/.pnpm/nuxt@4.0.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-_146d17ab30a9bf24368648cb0b07bbfb/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  cart: () => import("/opt/simploshop/shared/core-theme/app/middleware/cart.ts")
}